/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Trust_Never_ExpireInputs */

const en_pricing_trust_never_expire = /** @type {(inputs: Pricing_Trust_Never_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits never expire`)
};

const es_pricing_trust_never_expire = /** @type {(inputs: Pricing_Trust_Never_ExpireInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los créditos no caducan`)
};

/**
* | output |
* | --- |
* | "Credits never expire" |
*
* @param {Pricing_Trust_Never_ExpireInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_trust_never_expire = /** @type {((inputs?: Pricing_Trust_Never_ExpireInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Trust_Never_ExpireInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_trust_never_expire(inputs)
	return es_pricing_trust_never_expire(inputs)
});